import { ROUTES } from '@routes';

export const config: {
  nodeEnv: string;
  basename: string;
  defaultPath: string;
  i18n: string;
  api: {
    webApiHost: string;
    authApiHost: string;
  };
} = {
  nodeEnv: process.env.NODE_ENV ?? '',
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: '',
  defaultPath: ROUTES.dashboard,
  i18n: 'ru', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
  api: {
    webApiHost: process.env.REACT_APP_WEB_API_URL ?? '',
    authApiHost: process.env.REACT_APP_AUTH_API_URL ?? '',
  },
};
